import React from "react";
import { Link } from "react-router-dom";
import useLocales from "../../../hooks/useLocales";
import useSettings from "../../../hooks/useSettings";

// Error pages footer
const ErrorPageFooter = () => {
  // Get localization and theme direction using custom hooks
  const { translate } = useLocales();
  const { themeDirection } = useSettings();

  return (
    <>
      <div className="flex justify-center">
        <div className="2xl:max-w-screen-xl xl:max-w-screen-lg w-full">
          <div className="mx-5 my-7 smm:mx-5 sm:mx-5 md:mx-5">
            <hr className="border-t-1 border-gray-500 dark:border-color_v2_dark" />
            <div
              className={`flex flex-col md:flex-row justify-between mt-7 ${
                themeDirection === "rtl" ? "md:flex-row-reverse" : ""
              }`}
            >
              <div className="text-heading_color dark:text-color_v2_dark text-small1 mb-3">
                {/* Copyright © {year} bil.bio */}
                {translate("footer.copyright")}
              </div>
              <div className="text-small2_b text-dark_bg_v5 dark:text-color_v2_dark ">
                <Link to={"terms-of-service"}>
                  {/* Terms & Conditions */}
                  {translate("footer.terms_conditions")}
                </Link>{" "}
                ·{" "}
                <Link to={"privacy-policy"}>
                  {/* Privacy Policy */}
                  {translate("footer.privacy_policy")}
                </Link>
              </div>
              <div className="text-small2_b text-dark_bg_v5 dark:text-color_v2_dark ">
                <Link to={"Update_cookies_preferences"}>
                  {translate("footer.Update_cookies_preferences")}
                </Link>{" "}
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default ErrorPageFooter;
